export enum TileType {
    Normal = 'Normal',
    Absence = 'Absence',
    Global = 'Global',
}
